export const scoreIsNotAvailable = (score?: number | string) => {
  return score === undefined || score === 'not available'
}
